import * as React from "react";
import Divider from "@mui/material/Divider";
import Hero from "./components/Hero";
import LogoCollection from "./components/LogoCollection";
import Highlights from "./components/Highlights";
import Pricing from "./components/Pricing";
import Features from "./components/Features";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import WebsiteLayout from "../../layouts/website";
import { callBackendApi } from "../../methods/axiosInstances/backendInstance/apiRequest";

export default function MarketingPage() {
  const [stripeProducts, setStripeProducts] = React.useState([])

  const fetchStripeProducts = async () => {
    const response = await callBackendApi('/stripe-products', 'GET')
    if (response.success) {
      setStripeProducts(response.data)
    }
  }

  React.useEffect(() => {
    fetchStripeProducts()
  }, []);

  return (
    <>
    <WebsiteLayout>
      <Hero stripeProducts={stripeProducts} />
      <div>
        <LogoCollection />
        <Features />
        <Divider />
        <Testimonials />
        <Divider />
        <Highlights />
        <Divider />
        <Pricing stripeProducts={stripeProducts}/>
        <Divider />
        <FAQ />
        <Divider />
      </div>
      </WebsiteLayout>
    </>
  );
}
